import { useEffect, useState } from 'react'

export function useBrave() {
    const [isBrave, setIsBrave] = useState(false)

    const checkBrave = async () => {
        const response = await fetch(
            'https://api.duckduckgo.com/?q=useragent&format=json',
        )
        const result = await response.json()
        const { Answer } = result

        setIsBrave(Answer.includes('Brave'))
    }

    useEffect(() => {
        checkBrave()
    }, [])

    return isBrave
}
